export default "__VITE_ASSET__Cvc2iviu__"